<mat-form-field
  appearance="outline"
  [ngClass]="{ 'mat-form-field-readonly': readonly }"
  class="{{ formFieldClass }}"
>
  <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
    label | translate
  }}</mat-label>
  <input
    matInput
    type="time"
    [formControl]="control"
    [readonly]="readonly"
    (blur)="onTouched()"
    [required]="required"
    placeholder="HH:mm (H24)"
  />
  <mat-error
    *ngIf="control.hasError('required') && control.touched && required"
  >
    {{ requiredLabel | translate }}
  </mat-error>
</mat-form-field>
